import WebUtils from "../../utils/WebUtils";

let baseUrl = WebUtils.getProctorBaseUrl();
let proctorPlatformBaseUrl = `${baseUrl}/proctor-platform/api/v1`;

export const createCandidateCatalystInfoApi = `${proctorPlatformBaseUrl}/candidate/createCatalystInfo`;
export const getCandidateCatalystInfoApi = `${proctorPlatformBaseUrl}/candidate/getCatalystInfo`;
export const updateCandidateCatalystInfoApi = `${proctorPlatformBaseUrl}/candidate/updateCatalystInfo`;
export const passChangeApi = `${proctorPlatformBaseUrl}/account/changePassword`;
export const profileGetApi = `${proctorPlatformBaseUrl}/account/getProfileInfo`;
export const profilePostApi = `${proctorPlatformBaseUrl}/account/updateProfileInfo`;
export const getModuleAccessInfoApi = `${proctorPlatformBaseUrl}/account/getModuleAccessInfo`;
export const getJobGuidesApi = `${proctorPlatformBaseUrl}/jobGuide/getAll`;
export const createGuideApi = `${proctorPlatformBaseUrl}/jd/createJd`;
export const generateJdPostApi = `${proctorPlatformBaseUrl}/jobGuide/generateJdText`;
export const getGuideDetails = `${proctorPlatformBaseUrl}/jobGuide/getJobGuide`;
export const getGuideContentApi = `${proctorPlatformBaseUrl}/jobGuide/getContent`;
export const guideMarkAsCompleteApi = `${proctorPlatformBaseUrl}/jobGuide/markAsComplete`;
export const addNoteApi = `${proctorPlatformBaseUrl}/jobGuide/addNote`;
export const getNoteApi = `${proctorPlatformBaseUrl}/jobGuide/getNote`;
export const viewGuideViewJDApi = `${proctorPlatformBaseUrl}/jobGuide/viewJd`;
export const viewFreeGuideViewJDApi = `${proctorPlatformBaseUrl}/jd/freeGuide/view`;
export const getSaveDraftApi = `${proctorPlatformBaseUrl}/jobGuide/getDraftData`;
export const SaveDraftPostApi = `${proctorPlatformBaseUrl}/jobGuide/updateDraft`;
export const deleteNoteApi = `${proctorPlatformBaseUrl}/jobGuide/deleteNote`;
export const regenerateContentApi = `${proctorPlatformBaseUrl}/jobGuide/regenerateContent`;
export const requestAccessPostApi = `${proctorPlatformBaseUrl}/account/requestAccess`;

// free guides section
export const getIndustriesApi = `${proctorPlatformBaseUrl}/jobGuide/free/getIndustryTypes`;
export const getFreeGuidesApi = `${proctorPlatformBaseUrl}/jobGuide/free/getAll`;

export const getFreeGuideTopicsApi = `${proctorPlatformBaseUrl}/jobGuide/free/get`;
export const getFreeGuidesContentApi = `${proctorPlatformBaseUrl}/jobGuide/free/getContent`;
export const freeGuideMarkAsCompleteApi = `${proctorPlatformBaseUrl}/jobGuide/free/markAsComplete`;
export const getFreeGuidesNoteApi = `${proctorPlatformBaseUrl}/jobGuide/free/getNote`;
export const addFreeGuideNoteApi = `${proctorPlatformBaseUrl}/jobGuide/free/addNote`;
export const deleteFreeGuideNoteApi = `${proctorPlatformBaseUrl}/jobGuide/free/deleteNote`;

export const getFreeGuideBasicDetailsApi = `${proctorPlatformBaseUrl}/jobGuide/free/getBasicInfo`;
export const getGuideBasicDetailsApi = `${proctorPlatformBaseUrl}/jobGuide/getBasicInfo`;

//practice
export const getGenericFilterApi = `${proctorPlatformBaseUrl}/openpool/getFilterData`;
export const getGenericQuestionsApi = `${proctorPlatformBaseUrl}/openpool/question/getAll`;
export const getSingleGenericQuestionApi = `${proctorPlatformBaseUrl}/openpool/getQuestion`;

export const getIncrementCountApi = `${proctorPlatformBaseUrl}/openpool/activity-count/increment`;
export const postGenericSubmitAnswerApi = `${proctorPlatformBaseUrl}/openpool/submitAnswer`;

export const getJobSpecificFilterApi = `${proctorPlatformBaseUrl}/jobGuide/specificQuestions/getFilterData`;
export const getJobSpecificQuestionsApi = `${proctorPlatformBaseUrl}/jobGuide/specificQuestions/getAll`;
export const getSingleJobSpecificQuestionApi = `${proctorPlatformBaseUrl}/jobGuide/specificQuestions/get`;

export const getFreeJobSpecificQuestionsApi = `${proctorPlatformBaseUrl}/jobGuide/free/specificQuestions/getAll`;
export const getFreeJobSpecificFilterApi = `${proctorPlatformBaseUrl}/jobGuide/free/specificQuestions/getFilterData`;
export const getFreeSingleJobSpecificQuestionApi = `${proctorPlatformBaseUrl}/jobGuide/free/specificQuestions/get`;

export const getJobSpecificIncrementCountApi = `${proctorPlatformBaseUrl}/jobGuide/specificQuestion/practice-count/increment`;
export const postJobSpecificSubmitAnswerApi = `${proctorPlatformBaseUrl}/jobGuide/specificQuestion/submitAnswer`;

// create-jd
export const getAllJdsApi = `${proctorPlatformBaseUrl}/jd/getAll`;
export const getJdDetailsApi = `${proctorPlatformBaseUrl}/jd/get`;
export const getJdPreviewData = `${proctorPlatformBaseUrl}/jd/get`;
export const createNewApi = `${proctorPlatformBaseUrl}/jobGuide/createNew`;

//question bank
export const getQuestionBankTopicsApi = `${proctorPlatformBaseUrl}/jobGuide/getQuestionTopics`;
export const getQuestionBankSkillsApi = `${proctorPlatformBaseUrl}/jobGuide/getQuestionSkillList`;
export const getQuestionBankQuestionsApi = `${proctorPlatformBaseUrl}/jobGuide/getQuestionnaire`;
export const regenerateSkillsApi = `${proctorPlatformBaseUrl}/jobGuide/question/regenerate`;
export const bookmarkQuestionApi = `${proctorPlatformBaseUrl}/jobGuide/specificQuestion/bookmark`;

export const getFreeQuestionBankTopicsApi = `${proctorPlatformBaseUrl}/jobGuide/free/getQuestionTopics`;
export const getFreeQuestionBankSkillsApi = `${proctorPlatformBaseUrl}/jobGuide/free/getQuestionSkillList`;
export const getFreeQuestionBankQuestionsApi = `${proctorPlatformBaseUrl}/jobGuide/free/getQuestionnaire`;

//mock interview
export const getMockGuideApi = `${proctorPlatformBaseUrl}/iDrona/getAll`;
export const getBlueprintConfigApi = `${proctorPlatformBaseUrl}/iDrona/getConfiguration`;
export const getBlueprintJdDetailsApi = `${proctorPlatformBaseUrl}/iDrona/getJdDetails`;
export const getBlueprintAutoFillApi = `${proctorPlatformBaseUrl}/iDrona/getAutofillBlueprintData`;
export const postBlueprintCreateNew = `${proctorPlatformBaseUrl}/iDrona/createNew`;
export const getInterviewDataApi = `${proctorPlatformBaseUrl}/iDrona/getInterviewData`;
export const postScheduleInterview = `${proctorPlatformBaseUrl}/iDrona/scheduleInterview`;
export const postReScheduleInterview = `${proctorPlatformBaseUrl}/iDrona/reScheduleInterview`;
export const getGenerateInterviewSkills = `${proctorPlatformBaseUrl}/iDrona/generateInterviewSkills`;
export const postUpdateIDronaConfig = `${proctorPlatformBaseUrl}/iDrona/updateConfiguration`;
